import { createAsyncActionType } from './index';

export const TUTOR_COURSE_LIST_GET = createAsyncActionType(
  'tutorCourseList',
  'TUTOR_COURSE_LIST_GET'
);
export const UPDATE_COURSE_DETAILS_GET = createAsyncActionType(
  'tutorCourseList',
  'UPDATE_COURSE_DETAILS_GET'
);

export const TUTOR_COURSE_DELETE = createAsyncActionType(
  'tutorCourseList',
  'TUTOR_COURSE_DELETE'
);

export const TUTOR_EVENT_LIST_GET = createAsyncActionType(
  'tutorCourseList',
  'TUTOR_EVENT_LIST_GET'
);
